import { inject, Service } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { I18nBackendService } from './core/providers/backend/i18n-backend.service';
import { LanguageService } from './core/providers/backend/language.service';
import { ContextService } from './core/providers/context/context.service';
import { CONSTANTS } from './shared/constants';
import { SharedComponentViewType } from './shared/interfaces/common.interface';
import { ContextObject } from './shared/interfaces/login-object';

@Service()
export class ContextResolver {
  private contextService = inject(ContextService);
  private i18nBackendService = inject(I18nBackendService);
  private languageService = inject(LanguageService);

  resolve(): Observable<boolean> {
    return this.getContext$().pipe(
      take(1),
      mergeMap((context: ContextObject) => this.setAndGetDefaultLanguageForContext$(context))
    );
  }

  private getContext$(): Observable<ContextObject> {
    return this.contextService.getContext$();
  }

  private setAndGetDefaultLanguageForContext$(context: ContextObject): Observable<boolean> {
    if (context.uuid === undefined) {
      return EMPTY;
    }

    return this.i18nBackendService
      .getDefaultLanguageForContext$(
        context.uuid,
        context.type === CONSTANTS.CONTEXT.ACCOUNT
          ? SharedComponentViewType.ACCOUNT
          : SharedComponentViewType.VENUE
      )
      .pipe(
        map(defaultLanguage => {
          this.languageService.setDefaultLanguage(defaultLanguage);
          return true;
        })
      );
  }
}
